export default __webpack_public_path__ + "static/media/icn_arrow_left.0be42049.svg";